import ElasticSearch from '@lib/processors/elastic-processor'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
  },
  {
    attribute: 'externalId',
    label: 'External ID',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'supplierProductName',
    type: 'string',
    icon: 'el-icon-box',
  },
  {
    attribute: 'supplierProductSku',
    type: 'string',
    icon: 'el-icon-box',
  },
  {
    attribute: 'trackingCode',
    type: 'string',
    icon: 'el-icon-box',
  },
  {
    attribute: 'updatedAt',
    label: 'Last Updated',
    type: 'date',
    icon: 'el-icon-date',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    format: 'dateTime',
    width: 150,
  },
  {
    name: 'externalId',
    label: 'External ID',
    elasticSubField: 'lowercase',
    width: 260,
  },
  {
    name: 'supplierProductName',
    elasticSubField: 'lowercase',
    width: 320,
  },
  {
    name: 'supplierProductSku',
    elasticSubField: 'lowercase',
    width: 160,
  },
  {
    name: 'trackingCode',
    elasticSubField: 'lowercase',
    width: 130,
  },
  {
    name: 'updatedAt',
    label: 'Last Updated',
    format: 'dateTime',
    width: 150,
  },
]

export default component => ({
  processor: new ElasticSearch({
    component,
    index: 'order-items',
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'order-items',
})
